<!--
 * @Description: 销售线索 - 详情页面
 * @Author: mdb
 * @Date: 2022-07-06 11:33:06
 * @LastEditTime: 2023-02-20 10:36:45
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="dataForm?.customerName"
        :sellerName="dataForm?.followerName"
        :collection-id="dataForm?.collectionId"
        customLabel="线索类型"
        :customValue="clueTypeComputed"
        :add-fav="addFavorite"
        :cancel-fav="cancelFavorite"
      >
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" tab="基本信息">
            <DetailForm ref="detailFormRef" type="view" :isEdit="false" v-model:value="dataForm" />
            <!---审批记录的页面过来的：/fbu/customerProcessing/cluesAudit--->
            <ApplyRecord title="审批记录" v-if="route.query.isApplay === '1'" />
          </a-tab-pane>
          <a-tab-pane key="contact" tab="联系人">
            <TabsContacts
              ref="contactsRef"
              appId="cos_fbu"
              :contactRefId="queryClueId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="record" tab="跟进记录">
            <TabsClueCosFollowUp :permissionPage="permissionFollow" appId="cos_fbu" :followRefId="queryClueId" />
          </a-tab-pane>
          <a-tab-pane key="convert" tab="转化记录">
            <TabsConversion :resourceId="queryClueId" />
          </a-tab-pane>
          <a-tab-pane key="logs" tab="操作日志">
            <TabsOperationLog
              ref="operationLogRef"
              appId="cos_fbu"
              :resourceId="queryClueId"
              tableId="FbuSalesClueOperationLog"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <a-button v-if="!isPublicClue" v-permission="permissionConcat.add" @click="handleAddConcat()">新增联系人</a-button>
      <template v-if="!isPublicClue">
        <SellerButton
          v-permission="'fbu_clue_edit_btn'"
          controlType="none"
          @click="goToEdit()"
          >编辑</SellerButton
        >
        <a-button v-permission="'fbu_clue_person_btn'" @click="handleAssignPerson()">分配负责人</a-button>
        <SellerButton
          v-permission="'fbu_clue_potential_btn'"
          :workCode="dataForm.follower"
          controlType="none"
          @click="handleTurnPotential()"
          v-if="dataForm.clueStatus !== 8"
          >转为潜在客户</SellerButton
        >
      </template>
      <a-button
        v-permission="'fbu_clue_write_follow_btn'"
        type="primary"
        @click="handleWriteFollowUp()"
        v-if="!isPublicClue"
        >写跟进</a-button
      >
    </cos-footer-button>
  </dc-layout-main>

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleAssignPersonSuccess" />
  <!-- 新增联系人弹窗 -->
  <ConcatModal ref="concatModalRef" @success="successAddConcat" :contactRefId="queryClueId" />
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import TabsConversion from '@/components/TabsConversion'
import ApplyRecord from './components/ApplyRecord.vue'
import ClueAssign from '../components/ClueAssign.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ConcatModal from '@/components/TabsContacts/fbu/editModal.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/gucangSales/clueManage'
import { clueTypeEnum } from '@/views/gucangSales/clueManage/dataConfig'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { addToFav, cancelToFav } from '@/api/common'
const router = useRouter()
const route = useRoute()

const queryClueId = computed(() => route.query.clueId as string)
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
const clueTypeComputed = computed(() => {
  const find = clueTypeEnum.find((item) => item.value === dataForm?.clueType)
  return find?.label
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})
const permissionFollow = {
  edit: 'fbu_clue_follow_edit_btn',
  del: 'fbu_clue_follow_del_btn',
  comment: 'fbu_clue_follow_comment_btn'
}
const permissionConcat = {
  add: 'fbu_clue_contact_add_btn',
  edit: 'fbu_clue_contact_edit_btn',
  del: 'fbu_clue_contact_del_btn',
  isPublic: isPublicClue.value === '1'
}
const getDetails = () => {
  salesClueDetail({ clueId: queryClueId.value }).then((res) => {
    if (res.data.remindFlag === true) {
      res.data.remindFlag = 1
    } else if (res.data.remindFlag === false) {
      res.data.remindFlag = 0
    } else {
      res.data.remindFlag = undefined
    }
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => getDetails())

const activeTabs = ref('info')
const operationLogRef = ref()
const handleTabsChange = (val: any) => {
  if (val === 'info') {
    getDetails()
  } else if (val === 'logs') {
    operationLogRef.value?.fetch()
  }
}
const goToEdit = () => {
  router.push({ path: '/fbu/salesClue/edit', query: { clueId: queryClueId.value } })
}
// 新增联系人
const contactsRef = ref()
const concatModalRef = ref()
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successAddConcat = (type: any) => {
  contactsRef.value?.refresh(type)
  operationLogRef.value?.fetch()
  getDetails()
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  const data = [toRaw(dataForm)]
  clueAssignRef.value?.init(data)
}
const handleAssignPersonSuccess = (follower: string) => {
  getDetails()
  dataForm.follower = follower
}

// 跳转跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: { followRefId: queryClueId.value }
  })
}

// 转潜在客户
const handleTurnPotential = () => {
  if (dataForm.clueType === 3) return message.warning('无效线索不能转潜在客户')
  if (dataForm.dataIntegrity !== 100) {
    AModal.confirm({
      title: '请将客户资料补充完整！',
      content: '将客户信息补充完整，才能转潜在！',
      okText: '完善资料',
      onOk() {
        router.push({ path: '/fbu/salesClue/edit', query: { clueId: dataForm.clueId, isPerfect: 'required' } })
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onCancel() {}
    })
  } else {
    router.push({
      path: '/fbu/business/add',
      query: { saleChanceRefId: dataForm.clueId, isFromPotentialCustomer: 1 }
    })
  }
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_fbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = dataForm?.clueId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = null
      dataForm.collectionTime = null
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuSalesClueView' }
</script>

<style scoped></style>
